var _style, _polyline, _polyline2, _polyline3, _polyline4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line, _line2, _line3, _line4, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _text, _text2, _text3, _text4, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _text5, _text6, _text7, _text8, _text9, _g41, _g42, _g43, _g44, _g45, _g46, _g47;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurning7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_2_00000090989773469064383120000018239270075736347050_",
    width: "100%",
    height: "100%",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1585.7 957.2",
    style: {
      enableBackground: "new 0 0 1585.7 957.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:4.1358;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:1.3786;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#036EB8;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{fill:#C30D23; stroke-width:0; }\n\t.st4{font-family:'ArialMT'; stroke-width:0; }\n\t.st5{font-size:31px; stroke-width:0; }\n\t.st6{font-family:'AdobeFanHeitiStd-Bold-B5pc-H'; stroke-width:0; }\n\t.st7{font-size:55.3014px; stroke-width:0; }\n\t.st8{font-size:44.3106px; stroke-width:0; }\n\t.st9{fill:#FFFFFF; stroke-width:0; }\n\t.st10{fill:#354A5D; stroke-width:0; }\n\t.st11{fill:#E44C3C; stroke-width:0; }\n\t.st12{font-size:33.8508px; stroke-width:0; }\n\t.st13{fill:#231815; stroke-width:0; }\n\t.st14{font-size:41px; stroke-width:0; }\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1078.4,125.5 1078.4,311.1 1385.5,311.1 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "542.4,125.5 542.4,311.1 235.3,311.1 "
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1078.4,825 1078.4,639.3 1385.5,639.3 "
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "542.4,825 542.4,639.3 235.3,639.3 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 643.6,
    y: 164,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 643.6,
    y: 200.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 716.8,
    y: 200.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 570.4,
    y: 200.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 643.6,
    y: 237.2,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 716.8,
    y: 237.2,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 570.4,
    y: 237.2,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 905.2,
    y: 748.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 905.2,
    y: 712,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 712,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 978.3,
    y: 712,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 905.2,
    y: 675.5,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 675.5,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 978.3,
    y: 675.5,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1184.4,
    y: 420.6,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1184.4,
    y: 384,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1111.2,
    y: 384,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1111.2,
    y: 420.6,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1257.5,
    y: 384,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1184.4,
    y: 347.4,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1111.2,
    y: 347.4,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 1184.4,
    y: 530.1,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 1111.2,
    y: 530.1,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 1111.2,
    y: 566.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 1111.2,
    y: 493.5,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 363.5,
    y: 493.4,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 363.5,
    y: 530,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 436.6,
    y: 530,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 436.6,
    y: 493.4,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 290.3,
    y: 530,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 363.5,
    y: 566.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 436.6,
    y: 566.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 363.5,
    y: 384.1,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 436.6,
    y: 384.1,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 436.6,
    y: 347.5,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 436.6,
    y: 420.7,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 643.8,
    y: 712,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 643.8,
    y: 675.5,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 570.7,
    y: 675.5,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 717,
    y: 675.5,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 905.2,
    y: 200.6,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 905.2,
    y: 237.2,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 978.4,
    y: 237.2,
    onclick: " ",
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 832,
    y: 237.2,
    className: "st1",
    width: 73.2,
    height: 36.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1011.8,286.6c0,0,14,78.2,98.1,79.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1099.4,513.2c0,0-321.9-1.9-349.9-239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M869.4,287.8c0,0,1.2,204.4-359.7,224.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M523.7,364.9c0,0,78.2-3.5,86.4-89.9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M521.4,439.6c0,0,332.8,7,346.8,234.7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M753.8,665c0,0,8.2-217.2,357.3-225.4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1098.3,586.7c0,0-78.2,7-82.9,87.6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M606.6,665c0,0-4.4-80.1-96.7-80.1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 941.8,
    y1: 285.5,
    x2: 941.8,
    y2: 675.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 679,
    y1: 273.8,
    x2: 679,
    y2: 668.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 510.9,
    y1: 545.7,
    x2: 1098.3,
    y2: 545.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 521.4,
    y1: 406.4,
    x2: 1111.1,
    y2: 406.4
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "606.8,662.6 612.9,662.6 609.8,669.5 606.8,676.3 603.7,669.5 600.6,662.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "679.2,661.9 685.3,661.9 682.3,668.7 679.2,675.5 676.2,668.7 673.1,661.9 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "753.2,662.6 759.3,662.6 756.2,669.5 753.2,676.3 750.1,669.5 747.1,662.6 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1097.1,585.4 1097.1,579.3 1103.9,582.3 1110.7,585.4 1103.9,588.4 1097.1,591.5 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1097.1,544.9 1097.1,538.8 1103.9,541.8 1110.7,544.9 1103.9,548 1097.1,551 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1097.1,513.8 1097.1,507.6 1103.9,510.7 1110.7,513.8 1103.9,516.8 1097.1,519.9 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "1012.8,288.2 1006.7,288.2 1009.8,281.4 1012.8,274.6 1015.9,281.4 1018.9,288.2 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "942.8,288.2 936.6,288.2 939.7,281.4 942.8,274.6 945.8,281.4 948.9,288.2 "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "870,288.2 863.9,288.2 866.9,281.4 870,274.6 873,281.4 876.1,288.2 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "523.3,365.4 523.3,371.6 516.5,368.5 509.7,365.4 516.5,362.4 523.3,359.3 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "523.3,402.8 523.3,408.9 516.5,405.9 509.7,402.8 516.5,399.8 523.3,396.7 "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "523.3,439.4 523.3,445.5 516.5,442.5 509.7,439.4 516.5,436.3 523.3,433.3 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DRight_1_1",
    transform: "matrix(1 0 0 1 438.4463 376.8721)",
    className: "st4 st5"
  }, "0001"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "AForward_1_1",
    transform: "matrix(1 0 0 1 438.4463 414.2393)",
    className: "st4 st5"
  }, "0002"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CTotal_2",
    transform: "matrix(1 0 0 1 366.0449 414.2393)",
    className: "st4 st5"
  }, "0004"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BLeft_1_1",
    transform: "matrix(1 0 0 1 438.4463 449.2725)",
    className: "st4 st5"
  }, "0003"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CLeft_1",
    transform: "matrix(1 0 0 1 438.4463 522.983)",
    className: "st4 st5"
  }, "0005"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CForward_1",
    transform: "matrix(1 0 0 1 438.4463 560.3502)",
    className: "st4 st5"
  }, "0006"))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CRight_1",
    transform: "matrix(1 0 0 1 438.4463 595.3834)",
    className: "st4 st5"
  }, "0007"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CLeft_2",
    transform: "matrix(1 0 0 1 365.7041 522.983)",
    className: "st4 st5"
  }, "0008"))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CForward_2",
    transform: "matrix(1 0 0 1 365.7041 560.3502)",
    className: "st4 st5"
  }, "0009"))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CTotal_1",
    transform: "matrix(1 0 0 1 293.2165 560.3502)",
    className: "st4 st5"
  }, "0011"))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CRight_2",
    transform: "matrix(1 0 0 1 365.7041 595.3834)",
    className: "st4 st5"
  }, "0010"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "AForward_1",
    transform: "matrix(1 0 0 1 1112.923 414.2393)",
    className: "st4 st5"
  }, "0028"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "ALeft_1",
    transform: "matrix(1 0 0 1 1112.923 449.2725)",
    className: "st4 st5"
  }, "0029"))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "ARight_1",
    transform: "matrix(1 0 0 1 1112.923 376.8721)",
    className: "st4 st5"
  }, "0027"))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "AForward_2",
    transform: "matrix(1 0 0 1 1187.6603 414.2393)",
    className: "st4 st5"
  }, "0031"))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "ATotal_1",
    transform: "matrix(1 0 0 1 1258.8927 414.2393)",
    className: "st4 st5"
  }, "0033"))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "ALeft_2",
    transform: "matrix(1 0 0 1 1187.6603 449.2725)",
    className: "st4 st5"
  }, "0032"))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "ARight_2",
    transform: "matrix(1 0 0 1 1187.6603 376.8721)",
    className: "st4 st5"
  }, "0030"))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BLeft_2",
    transform: "matrix(1 0 0 1 833.9874 742.3775)",
    className: "st4 st5"
  }, "0019"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BLeft_1",
    transform: "matrix(1 0 0 1 833.9874 705.0093)",
    className: "st4 st5"
  }, "0016"))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BRight_2",
    transform: "matrix(1 0 0 1 981.292 742.3775)",
    className: "st4 st5"
  }, "0021"))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BRight_1",
    transform: "matrix(1 0 0 1 981.292 705.0093)",
    className: "st4 st5"
  }, "0018"))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BForward_2",
    transform: "matrix(1 0 0 1 907.7246 742.3775)",
    className: "st4 st5"
  }, "0020"))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BTotal_1",
    transform: "matrix(1 0 0 1 907.7246 777.4097)",
    className: "st4 st5"
  }, "0022"))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BForward_1",
    transform: "matrix(1 0 0 1 907.7246 705.0093)",
    className: "st4 st5"
  }, "0017"))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DRight_1",
    transform: "matrix(1 0 0 1 571.2442 267.1025)",
    className: "st4 st5"
  }, "0042"))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DRight_2",
    transform: "matrix(1 0 0 1 571.2442 229.7354)",
    className: "st4 st5"
  }, "0039"))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DLeft_1",
    transform: "matrix(1 0 0 1 719.5489 267.1025)",
    className: "st4 st5"
  }, "0044"))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DLeft_2",
    transform: "matrix(1 0 0 1 719.5489 229.7354)",
    className: "st4 st5"
  }, "0041"))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DForward_1",
    transform: "matrix(1 0 0 1 645.9806 267.1025)",
    className: "st4 st5"
  }, "0043"))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DForward_2",
    transform: "matrix(1 0 0 1 645.9806 229.7354)",
    className: "st4 st5"
  }, "0040"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "CLeft_1_1",
    transform: "matrix(1 0 0 1 833.9673 267.1025)",
    className: "st4 st5"
  }, "0035")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "ARight_1_1",
    transform: "matrix(1 0 0 1 982.2726 267.1025)",
    className: "st4 st5"
  }, "0037")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "BForward_1_1",
    transform: "matrix(1 0 0 1 908.7042 267.1025)",
    className: "st4 st5"
  }, "0036")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "DTotal_2",
    transform: "matrix(1 0 0 1 908.7042 229.7354)",
    className: "st4 st5"
  }, "0034")), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DTotal_1",
    transform: "matrix(1 0 0 1 645.9806 193.5342)",
    className: "st4 st5"
  }, "0038"))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CRight_1_1",
    transform: "matrix(1 0 0 1 571.6743 705.0093)",
    className: "st4 st5"
  }, "0012"))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "ALeft_1_1",
    transform: "matrix(1 0 0 1 719.9789 705.0093)",
    className: "st4 st5"
  }, "0014"))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BTotal_2",
    transform: "matrix(1 0 0 1 646.4106 742.3775)",
    className: "st4 st5"
  }, "0015"))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DForward_1_1",
    transform: "matrix(1 0 0 1 646.4106 705.0093)",
    className: "st4 st5"
  }, "0013"))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "CForward_1_1",
    transform: "matrix(1 0 0 1 1112.923 560.2076)",
    className: "st4 st5"
  }, "0024"))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "BRight_1_1",
    transform: "matrix(1 0 0 1 1112.923 595.2418)",
    className: "st4 st5"
  }, "0025"))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "DLeft_1_1",
    transform: "matrix(1 0 0 1 1112.923 522.8409)",
    className: "st4 st5"
  }, "0023"))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "ATotal_2",
    transform: "matrix(1 0 0 1 1186.6602 560.2076)",
    className: "st4 st5"
  }, "0026"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 671.2067 74.8816)",
    className: "st6 st7"
  }, "\u5357\u5C71\u8DEF\u4E09\u6BB5")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 671.2067 903.7585)",
    className: "st6 st7"
  }, "\u5357\u5C71\u8DEF\u4E09\u6BB5")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 41.5026 504.3767)",
    className: "st6 st7"
  }, "\u6D77\u5C71\u8DEF")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1387.88 482.7027)",
    className: "st6 st7"
  }, "\u5C71\u6797\u8DEF")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1415.58 549.1028)",
    className: "st6 st7"
  }, "\u4E00\u6BB5")), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)",
    "transform-origin": "1336px 139px"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 1336.9,
    cy: 139.6,
    r: 38.8
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1252.2754 105.0975) rotate(0)",
    "transform-origin": "15px -15px",
    className: "st6 st8"
  }, "N"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1358.4,108.5 1363.7,113.2 1366,105.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1314.5,169.5 1309.1,164.8 1306.8,172.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1305.9,117.1 1310.6,111.7 1302.6,109.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "1366.9,161 1362.2,166.3 1370.3,168.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1307.6,114c-14.1,16.1-12.5,40.7,3.7,54.8c16.1,14.1,40.7,12.5,54.8-3.7c14.1-16.1,12.5-40.7-3.7-54.8 C1346.3,96.2,1321.7,97.9,1307.6,114z M1310,116.1c13-14.8,35.5-16.3,50.3-3.4c14.8,13,16.3,35.5,3.4,50.3 c-13,14.8-35.5,16.3-50.3,3.4C1298.6,153.4,1297.1,130.9,1310,116.1z"
  })))))), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "1339.9,172.4 1346.3,148.8 1369.1,140.5 1313.5,118.8  "
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Date",
    transform: "matrix(1 0 0 1 1190.1581 743.0448)",
    className: "st6 st12"
  }, "\u65E5\u671F\uFF1A\u897F\u5143/\u6708/\u65E5"))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    id: "Time",
    transform: "matrix(1 0 0 1 1190.1581 800.6447)",
    className: "st6 st12"
  }, "\u6642\u9593\uFF1AAA:BB-CC:DD"))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1349.4368 417.4868)",
    className: "st13 st6 st14"
  }, "A"))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 932.4021 831.6631)",
    className: "st13 st6 st14"
  }, "B"))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 244.6264 562.8747)",
    className: "st13 st6 st14"
  }, "C"))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 666.6848 146.8986)",
    className: "st13 st6 st14"
  }, "D"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurning7);
export default __webpack_public_path__ + "static/media/turning7.d051bc81d522469379ec11f2a3b40b33.svg";
export { ForwardRef as ReactComponent };